import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faShoppingCart, faBell, faUser, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import SearchBar from "./Searchbar";

const DesktopHeader = ({
	isAuthenticated,
	user,
	wishlistCount,
	cartCount,
	unreadCount,
	notifications,
	onLogout,
	onLoginClick,
	onSearchSubmit,
	navigate,
	setIsNotifDropdownOpen,
	onClearAll,
	onRemoveOne,
	onSeeAll
}) => {
	const notifDropdownRef = useRef(null);

	const toggleNotifDropdown = () => {
		setIsNotifDropdownOpen(prev => !prev);
	};

	return (
		<div className="hidden lg:block bg-[#FDFBF7] border-b border-stone-200 relative z-50">
			{/* Micro wood grain texture overlay to match footer */}
			<div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/pinstriped-suit.png')]"></div>

			<div className="container mx-auto flex flex-col md:flex-row justify-between items-center p-5 relative">

				{/* Logo Section */}
				<div
					className="flex items-center space-x-3 mb-4 md:mb-0 cursor-pointer group"
					onClick={() => navigate("/")}
				>
					<div className="relative">
						<img src="/assets/zakkuu logo bg.png" alt="Logo" className="h-14 transition-transform duration-500 group-hover:scale-105" />
					</div>
				</div>

				<SearchBar onSearchSubmit={onSearchSubmit} />

				{/* Right Side Icons - The "Brass & Wood" Toolbar */}
				<div className="flex items-center space-x-5 md:space-x-8 w-full md:w-auto justify-end">
					{isAuthenticated && (
						<>
							{/* Wishlist */}
							<div className="relative group" title="Wishlist">
								<Link to="/wishlist" className="flex items-center text-stone-600 hover:text-[#7A5C33] transition-colors duration-300">
									<FontAwesomeIcon icon={faHeart} size="lg" />
									{wishlistCount > 0 && (
										<span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold text-white bg-[#7A5C33] rounded-full shadow-sm">
											{wishlistCount}
										</span>
									)}
								</Link>
							</div>

							{/* Cart */}
							<div className="relative group" title="Cart">
								<Link to="/cart" className="text-stone-600 hover:text-[#7A5C33] transition-colors duration-300">
									<FontAwesomeIcon icon={faShoppingCart} size="lg" />
									{cartCount > 0 && (
										<span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold text-white bg-[#7A5C33] rounded-full shadow-sm">
											{cartCount}
										</span>
									)}
								</Link>
							</div>

							{/* Notifications */}
							<div className="relative" ref={notifDropdownRef}>
								<button
									onClick={toggleNotifDropdown}
									className="relative text-stone-600 hover:text-[#7A5C33] transition-colors duration-300 outline-none"
									title="Notifications"
								>
									<FontAwesomeIcon icon={faBell} size="lg" />
									{unreadCount > 0 && (
										<span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold text-white bg-[#A38A64] rounded-full shadow-sm">
											{unreadCount}
										</span>
									)}
								</button>
							</div>
						</>
					)}

					{/* Profile / Auth Actions */}
					<div className="flex items-center border-l border-stone-200 pl-6 space-x-6">
						{isAuthenticated ? (
							<>
								<Link
									to="/profile"
									className="text-stone-600 hover:text-stone-900 transition-colors duration-300"
									title="Profile"
								>
									<FontAwesomeIcon icon={faUser} size="lg" />
								</Link>

								<button
									onClick={onLogout}
									className="text-stone-400 hover:text-red-700 transition-colors duration-300"
									title="Logout"
								>
									<FontAwesomeIcon icon={faSignOutAlt} size="lg" />
								</button>
							</>
						) : (
							<div
								className="flex items-center space-x-3 cursor-pointer group"
								onClick={onLoginClick}
							>
								<div className="w-10 h-10 flex items-center justify-center bg-stone-100 group-hover:bg-[#7A5C33] group-hover:text-white rounded-none transition-all duration-300 border border-stone-200">
									<FontAwesomeIcon icon={faUser} />
								</div>
								<button className="text-stone-800 font-serif font-bold text-sm uppercase tracking-widest hidden md:inline">
									Login
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default DesktopHeader;
